import { Button, Result } from "antd";
import React, { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import ListTable from "./components/ListTable";
import { AppDispatch } from "../../../store/app";
import { useDispatch } from "react-redux";
import { fetchListUser } from "../../../store/UserSlice";
import { checkPrivileges } from "../../../config/Global";
import AddUser from "./components/AddUser";
import EditUser from "./components/EditUser";

const Providers: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [dataEditModal, setDataEditModal] = useState<any>();

  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [savePayload, setSavePayload] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    current: 1,
    page_size: 10,
  });

  const userDetails = localStorage.getItem("userDetails");
  const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const getList = (data?: any) => {
    setTableLoading(true);
    const payload = {
      ...data,
      current: data?.current ?? paginationData?.current ?? 1,
      page_size: data?.page_size ?? paginationData?.page_size ?? 10,
    };
    setSavePayload(payload);
    dispatch(fetchListUser(payload))
      .then((res: any) => {
        setListData(res?.data);
        setTotalData(res?.total_data);
        setTableLoading(false);
      })
      .catch(() => {
        setListData([]);
        setTotalData(0);
        setTableLoading(false);
      });
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddModal = () => {
    setOpenAddModal(!openAddModal);
  };

  const handleEditModal = (data?: any) => {
    setOpenEditModal(!openEditModal);
    if (data) {
      setDataEditModal(data);
    }
  };

  return (
    <>
      <ToolBar
        title={"Users"}
        children={
          <>
            {checkPrivileges(userRoles, "admin") ? (
              <Button type="primary" onClick={handleAddModal}>
                Add New
              </Button>
            ) : null}
          </>
        }
      />
      {checkPrivileges(userRoles, "admin") ? (
        <ListTable
          listData={listData}
          setListData={setListData}
          totalData={totalData}
          tableloading={tableloading}
          setTableLoading={setTableLoading}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          getList={getList}
          savePayload={savePayload}
          handleEditModal={handleEditModal}
        />
      ) : (
        <Result
          status="403"
          title="403"
          subTitle="You don't have enough permission to perform this action."
        />
      )}

      {openAddModal ? (
        <AddUser
          handleAddModa={handleAddModal}
          openAddModal={openAddModal}
          getList={getList}
        />
      ) : null}
      {openEditModal ? (
        <EditUser
          handleEditModal={handleEditModal}
          dataEditModal={dataEditModal}
          openEditModal={openEditModal}
          getList={getList}
        />
      ) : null}
    </>
  );
};
export default Providers;
